<div class="flex flex-col gap-2 p-2">
	<p class="text-sm text-gray-600 text-[10px]">(optionnel)</p>
	<textarea
		[(ngModel)]="comment"
		class="textarea textarea-bordered w-full min-h-24 bg-white focus:outline-none"
		placeholder="Ex: diagnostiqué en 2020, suivi régulier..."
		rows="4"
	></textarea>
	<div class="flex justify-end gap-2 pt-3 mt-4 border-t border-gray-100">
		<button type="button" class="btn btn-sm btn-ghost" (click)="cancel()">
			Annuler
		</button>
		<button type="button" class="btn btn-sm btn-primary" (click)="validate()">
			Valider
		</button>
	</div>
</div>
